import { Box, FormControlLabel, Switch } from '@mui/material'
import AppFormBaseField from '../AppFormBaseField'
import { App } from 'features/apps/types'
import { isValidURL } from 'features/common/utils/urlValidation'
import { NonSubmitableForm } from 'features/common'
import { Typography } from '@carto/meridian-ds/components'
import { FormattedMessage } from 'react-intl'
import { Controller } from 'react-hook-form'

const TITLE_MAX_LENGTH = 60

interface AppsFormCommonSectionFieldsProps {
  app: App | undefined
  registered?: boolean
  form: NonSubmitableForm
}

function AppsFormCommonSectionFields({ form, app, registered }: AppsFormCommonSectionFieldsProps) {
  const {
    control,
    register,
    formState: { errors }
  } = form
  return (
    <>
      <Box>
        <AppFormBaseField
          register={register('title', { required: true })}
          key="title"
          name="title"
          defaultValue={app?.title}
          maxLength={TITLE_MAX_LENGTH}
          labelId="apps.create.formBasic.nameLabel"
          placeholderId="apps.create.formBasic.namePlaceholder"
        />
      </Box>
      <Box mt={3}>
        <AppFormBaseField
          register={register('description', { required: registered })}
          key="description"
          name="description"
          defaultValue={app?.description}
          labelId="apps.create.formBasic.descriptionLabel"
          placeholderId="apps.create.formBasic.descriptionPlaceholder"
          helpTextId="apps.create.formBasic.descriptionHelper"
          multiline={true}
          optional={!registered}
        />
      </Box>
      <Box mt={3}>
        <AppFormBaseField
          register={register('url', { required: true, validate: isValidURL })}
          key="url"
          name="url"
          defaultValue={app?.url}
          labelId="apps.create.formBasic.appUrlLabel"
          placeholderId="apps.create.formBasic.appUrlPlaceholder"
          errorMessageId="apps.create.errors.url"
          hasErrors={!!errors.url}
        />
      </Box>
      <Box mt={3}>
        <AppFormBaseField
          register={register('thumbnail_url', {
            validate: (value) => {
              if (!value) return true
              return isValidURL(value)
            }
          })}
          key="thumbnail_url"
          name="thumbnail_url"
          defaultValue={app?.thumbnail_url}
          labelId="apps.create.formBasic.thumbnailUrlLabel"
          placeholderId="apps.create.formBasic.thumbnailUrlLabel"
          helpTextId="apps.create.formBasic.thumbnailUrlHelper"
          optional={true}
          errorMessageId="apps.create.errors.url"
          hasErrors={!!errors.thumbnail_url}
        />
      </Box>
      <Box mt={3}>
        <Controller
          name="bookmarked"
          control={control}
          defaultValue={app?.bookmarked}
          render={({ field }) => (
            <>
              <FormControlLabel
                control={<Switch {...field} value={field.value} defaultChecked={app?.bookmarked} />}
                label={<FormattedMessage id="apps.cards.actions.pin" />}
                labelPlacement="end"
              />
              <Typography variant="caption" component="div" mt={1} color="textSecondary">
                <FormattedMessage id="apps.create.formBasic.pinHelper" />
              </Typography>
            </>
          )}
        />
      </Box>
    </>
  )
}

export default AppsFormCommonSectionFields
